import { ErpDataTableV2 } from './data-table-v2';

export const AritoDataTables: any = ErpDataTableV2;
export const ErpDataTables: any = ErpDataTableV2;
export { ActionBarV2 as AritoActionBar } from './action-bar-v2';
export { ActionButtonV2 as AritoActionButton } from './action-button-v2';
export { MenuButtonV2 as AritoMenuButton } from './menu-button-v2';
export { FormFieldV2 as FormField } from './form-field-v2';
export { SearchFieldV2 as SearchField } from './search-field-v2';
export { DocumentNumberFieldV2 as DocumentNumberField } from './document-number-v2';
export { CurrencyInputV2 as CurrencyInput } from './currency-input-v2';
export { DvtFieldV2 as DvtField } from './dvt-field-v2';
export { DeleteDialogV2 as DeleteDialog } from './delete-dialog-v2';
export { HeaderTabsV2 as AritoHeaderTabs } from './header-tabs-v2';
export { DialogV2 as AritoDialog } from './dialog-v2';
export { AritoFormV2 as AritoForm } from './form-v2';
export { BottomActionBarV2 as BottomBar } from './bottom-action-bar-v2';
export { LoadingOverlayV2 as LoadingOverlay } from './loading-overlay-v2';
export { UnitDropdownV2 as UnitDropdown } from './unit-dropdown-v2';
export { ErpInputTableV2 as InputTable } from './input-table-v2';
export {
  IconActionButtonV2 as LocalActionButton,
  IconActionButtonV2 as AritoIconActionButton
} from './icon-action-button-v2';
export { default as ConfirmationDialog } from './confirmation-dialog-v2';
export { default as InfoDropdown } from './info-dropdown-v2';
